import { AxiosResponse } from 'axios';

import API from '../Api';
import { getUserToken, logUserOut } from '../utils/login';
// Types.
import { MarketingPermissions } from '../types/customer';

export const getMarketingPermissions = async (dataOwnerCustomerId: number): Promise<MarketingPermissions> => {
  const { bearer, content } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  const getMarketingPermissions: AxiosResponse<MarketingPermissions> = await API({
    method: 'post',
    url: `/v1/marketingPermissions/${dataOwnerCustomerId}`,
    headers: {
      Authorization: `Bearer ${bearer}`,
    },
    data: {
      content: `${content}`,
    },
  });
  return getMarketingPermissions.data;
};
export const patchMarketingPermissions = async (
  dataOwnerCustomerId: number,
  marketingNewsLetter: boolean,
  marketingEmail: boolean,
  marketingSMS: boolean,
): Promise<number | []> => {
  const { bearer, content } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  try {
    const patchMarketingPermissions: AxiosResponse<MarketingPermissions> = await API({
      method: 'patch',
      url: `/v1/marketingPermissions/${dataOwnerCustomerId}`,
      headers: {
        Authorization: `Bearer ${bearer}`,
      },
      data: {
        marketingNewsLetter: marketingNewsLetter,
        marketingEmail: marketingEmail,
        marketingSMS: marketingSMS,
        content: `${content}`,
      },
      validateStatus: function (status) {
        return status === 204 || status === 404;
      },
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          logUserOut();
        }
        return error.response;
      }
    });

    return patchMarketingPermissions.status;
    // eslint-disable-next-line
  } catch (e) {
    return [];
  }
};
